import { render, staticRenderFns } from "./ProgramacionInformeForm.vue?vue&type=template&id=b27ed6a6&scoped=true&"
import script from "./ProgramacionInformeForm.vue?vue&type=script&lang=ts&"
export * from "./ProgramacionInformeForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramacionInformeForm.vue?vue&type=style&index=0&id=b27ed6a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27ed6a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b27ed6a6', component.options)
    } else {
      api.reload('b27ed6a6', component.options)
    }
    module.hot.accept("./ProgramacionInformeForm.vue?vue&type=template&id=b27ed6a6&scoped=true&", function () {
      api.rerender('b27ed6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ProgramacionInforme/ProgramacionInformeForm.vue"
export default component.exports